// Copyright © 2021 Move Closer
export const defaultPerPage = 25;
